export const CourseStatut = {
  PaymentAttente: 0,
  PreReserve: 1,
  Affecte: 2,
  Annulee: 3,
  ClientAbsent: 4,
  FausseCourse: 5,
  Terminee: 6,
  EnCours: 7,
  ChauffeurEnRoute: 8,
  ChauffeurSurPlace: 9,
  Dispatching: 10,
};

export type CourseStatut = (typeof CourseStatut)[keyof typeof CourseStatut];

export const CourseStatutLabel: Record<CourseStatut, string> = {
  [CourseStatut.PaymentAttente]: "En attente de paiement",
  [CourseStatut.Dispatching]: "À dispatcher",
  [CourseStatut.PreReserve]: "Pré-réservé",
  [CourseStatut.Affecte]: "Affecté",
  [CourseStatut.Annulee]: "Annulé",
  [CourseStatut.ClientAbsent]: "Client absent",
  [CourseStatut.FausseCourse]: "Fausse course",
  [CourseStatut.Terminee]: "Terminé",
  [CourseStatut.EnCours]: "En cours",
  [CourseStatut.ChauffeurEnRoute]: "Chauffeur en route",
  [CourseStatut.ChauffeurSurPlace]: "Chauffeur sur place",
};

// Clé de traduction (enums.course_statut.*) associée à chaque statut,
// pour éviter de dupliquer cette correspondance dans chaque page.
export const CourseStatutTranslationKey: Record<CourseStatut, string> = {
  [CourseStatut.PaymentAttente]: "payment_attente",
  [CourseStatut.Dispatching]: "dispatching",
  [CourseStatut.PreReserve]: "pre_reserve",
  [CourseStatut.Affecte]: "affecte",
  [CourseStatut.Annulee]: "annulee",
  [CourseStatut.ClientAbsent]: "client_absent",
  [CourseStatut.FausseCourse]: "fausse_course",
  [CourseStatut.Terminee]: "terminee",
  [CourseStatut.EnCours]: "en_cours",
  [CourseStatut.ChauffeurEnRoute]: "chauffeur_en_route",
  [CourseStatut.ChauffeurSurPlace]: "chauffeur_sur_place",
};

// Libellés vus par le client (passager / gestionnaire) : le dispatching, la
// proposition et l'acceptation se confondent en « Réservé », comme sur le mobile.
export const CourseStatutClientTranslationKey: Record<CourseStatut, string> = {
  ...CourseStatutTranslationKey,
  [CourseStatut.Dispatching]: "client_reserve",
  [CourseStatut.PreReserve]: "client_reserve",
  [CourseStatut.Affecte]: "client_reserve",
  [CourseStatut.PaymentAttente]: "client_payment_attente",
  [CourseStatut.ChauffeurSurPlace]: "client_chauffeur_sur_place",
  [CourseStatut.EnCours]: "client_en_cours",
};

export function buildCourseStatutLabels(
  tEnums: (key: string) => string,
): Record<CourseStatut, string> {
  return Object.fromEntries(
    Object.entries(CourseStatutTranslationKey).map(([statut, key]) => [
      statut,
      tEnums(`course_statut.${key}`),
    ]),
  ) as Record<CourseStatut, string>;
}
